import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eMedicationActionTypeIds, IMedicationActionTypes } from "../../action-types/y-te/IMedicationActionTypes";
import { IMedicationPageStateModel } from "../../page-state-model/y-te/IMedicationPageState";

const initialState: IMedicationPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	medications: [],
	medication_editing: undefined,
	medication_selected_ids: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false,
	is_loading_detail: false,
	is_show_dangky_modal: false,
	dangky_status: ePageBaseStatus.is_not_initialization,
	medications_dangky: []
}

export const medicationReducer = (state: IMedicationPageStateModel = initialState, action: IMedicationActionTypes): IMedicationPageStateModel => {
	switch (action.type) {
		case eMedicationActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eMedicationActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				medications: action.payload
			}
		case eMedicationActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				medications: []
			}
		case eMedicationActionTypeIds.LOAD_DETAIL_START:
			return {
				...state,
				is_loading_detail: true
			}
		case eMedicationActionTypeIds.LOAD_DETAIL_SUCCESS:
			return {
				...state,
				is_loading_detail: false,
				medication_editing: action.payload
			}
		case eMedicationActionTypeIds.LOAD_DETAIL_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				is_loading_detail: false
			}
		case eMedicationActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				medication_editing: action.payload
			}
		case eMedicationActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				medication_editing: undefined
			}
		case eMedicationActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				medication_selected_ids: action.payload
			}
		case eMedicationActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eMedicationActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eMedicationActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eMedicationActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				medication_editing: undefined
			}
		case eMedicationActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eMedicationActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eMedicationActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				medication_editing: undefined,
				medication_selected_ids: []
			}
		case eMedicationActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eMedicationActionTypeIds.SHOW_DANGKY_MODAL:
			return {
				...state,
				is_show_dangky_modal: true,
				dangky_status: ePageBaseStatus.is_not_initialization,
				medications_dangky: []
			}
		case eMedicationActionTypeIds.CLOSE_DANGKY_MODAL:
			return {
				...state,
				is_show_dangky_modal: false,
				dangky_status: ePageBaseStatus.is_not_initialization,
				medications_dangky: []
			}
		case eMedicationActionTypeIds.LOAD_DANGKY_START:
			return {
				...state,
				dangky_status: ePageBaseStatus.is_loading
			}
		case eMedicationActionTypeIds.LOAD_DANGKY_SUCCESS:
			return {
				...state,
				dangky_status: ePageBaseStatus.is_completed,
				medications_dangky: action.payload
			}
		case eMedicationActionTypeIds.LOAD_DANGKY_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				dangky_status: ePageBaseStatus.is_completed,
				medications_dangky: []
			}
		case eMedicationActionTypeIds.CHANGE_DANGKY_DATAS:
			return {
				...state,
				medications_dangky: action.payload
			}
		case eMedicationActionTypeIds.SAVE_DANGKY_START:
			return {
				...state,
				dangky_status: ePageBaseStatus.is_saving
			}
		case eMedicationActionTypeIds.SAVE_DANGKY_SUCCESS:
			NotifyHelper.Success("Cập nhật thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				dangky_status: ePageBaseStatus.is_completed,
				is_show_dangky_modal: false,
				medications_dangky: []
			}
		case eMedicationActionTypeIds.SAVE_DANGKY_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				dangky_status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
